import { Navigate, useLocation } from "react-router";

/** redirect ที่พา query string เดิมไปด้วย (ช่วงเวลา/ตัวกรองของลิงก์เก่า) */
export function KeepQueryRedirect({ to }: { to: string }) {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace />;
}
